<template>
  <forgot-password-layout>
    <template slot="main">
      <section>
        <h1>{{ $_getTranslations.visitor_forgot_password_1_title }}</h1>

        <read-only-stepper-header
          v-if="!hasStepsToDisplay"
          :total-steps="3"
          :active-step="1"
        ></read-only-stepper-header>

        <img src="/static/images/register/mobile_img.svg" class="register_mobile" alt="mobile image"/>

        <h2>{{ $_getTranslations.visitor_forgot_password_1_forgot }}</h2>

        <p>{{ $_getTranslations.visitor_forgot_password_1_description }}</p>

        <base-phone-number-form-input
          :model-value="formValues.msisdn"
          :label="$_getTranslations.visitor_forgot_password_input_label_phone_number"
          :invalid="msisdnInputValidationConfiguration.invalid"
          @update:modelValue="handleMsisdnChange"
        ></base-phone-number-form-input>

        <div v-if="msisdnInputValidationConfiguration.invalid" class="error_text">
          {{ msisdnInputValidationConfiguration.message }}
        </div>

        <base-button
          :disabled="isSubmitButtonDisabled"
          container-class="continue"
          @button:click.prevent="handleSubmit"
        >
          {{ $_getTranslations.visitor_forgot_password_button_continue }}
        </base-button>
      </section>
    </template>
  </forgot-password-layout>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import BasePhoneNumberFormInput from '../../common/formInput/BasePhoneNumberFormInput'
import BaseButton from '../../common/button/BaseButton'
import ReadOnlyStepperHeader from '../../common/header/ReadOnlyStepperHeader'
import ForgotPasswordLayout from './ForgotPasswordLayout'
import RegistrationFlowMixin from '../../../common/mixins/flow'
import translationMixin from '../../../common/mixins/translation'
import {getApiResponseErrorMessage} from '../../../helpers/api'
import {apiResponseTypeEnum} from '../../../constants/api'
import {forgotPasswordErrorMessagesPerResponseType} from '../../../constants/forgotPassword'

const validationRegexMsisdn = /^[0-9]||[()+-]{0,20}$/

export default {
  name: 'forgotPassword1',
  components: {
    BasePhoneNumberFormInput,
    BaseButton,
    ReadOnlyStepperHeader,
    ForgotPasswordLayout
  },
  mixins: [
    RegistrationFlowMixin,
    translationMixin
  ],
  data () {
    return {
      formValues: {msisdn: ''},
      msisdnInputValidationConfiguration: {invalid: false, message: ''},
      hasStepsToDisplay: false
    }
  },
  created () {
    this.hasStepsToDisplay = this.hasSimplify()
  },
  methods: {
    ...mapMutations('profile', [
      'setForgotPasswordInfo'
    ]),
    validateForm () { // not used
      this.msisdnInputValidationConfiguration.invalid = !this.formValues.msisdn.match(validationRegexMsisdn)

      if (this.msisdnInputValidationConfiguration.invalid) {
        this.msisdnInputValidationConfiguration.message = this.$_translateTextByOperator({key: 'visitor_forgot_password_error_msisdn_invalid'})
      }
    },
    resetErrors () {
      if (this.msisdnInputValidationConfiguration.invalid) {
        this.msisdnInputValidationConfiguration.invalid = false
        this.msisdnInputValidationConfiguration.message = ''
      }
    },
    handleMsisdnChange (value) {
      this.formValues.msisdn = value

      if (this.msisdnInputValidationConfiguration.invalid) {
        this.resetErrors()
      }
    },
    handleSubmit () {
      this.resetErrors()

      this.$axios.get(`api/requestNewPin?msisdn=${this.formValues.msisdn}&lang=${this.getLocale}`).then(response => {
        const {responseEnum, data: responseData} = response.data

        if (responseEnum === apiResponseTypeEnum.OPERATION_SUCCESS) {
          this.setForgotPasswordInfo(responseData)
          this.getNextForgotPasswordStep()()
        } else {
          this.msisdnInputValidationConfiguration.message = this.$_translateTextByOperator({
            key: getApiResponseErrorMessage(responseEnum, forgotPasswordErrorMessagesPerResponseType)
          })
          this.msisdnInputValidationConfiguration.invalid = true
        }
      })
    }
  },
  computed: {
    ...mapGetters('i18n', [
      'getLocale'
    ]),
    isSubmitButtonDisabled () {
      return !this.formValues.msisdn
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/visitor/forgotPassword/ForgotPassword1.vue